import React from 'react'
import Drawer from '@mui/material/Drawer'
import { Box } from '@mui/material'

const RecruitmentDrawerComponent = ({
  state,
  onClose,
  anchor,
  headerprops,
  children,
  sx,
  sxHeader,
  sxIcon,
  ...rest
}) => {
  const list = () => (
    <Box
      width={{ xs: '100vw', lg: 710 }}
      sx={{ height: '100vh', ...sx }}
      boxSizing="border-box"
      role="presentation"
      {...rest}
      className="scrollbar"
    >
      <Box>{children}</Box>
    </Box>
  )

  return (
    <>
      <Box key={anchor}>
        <Drawer anchor={anchor} open={state[anchor]} onClose={onClose(anchor, false)}>
          {list(anchor)}
        </Drawer>
      </Box>
    </>
  )
}

export default RecruitmentDrawerComponent
